import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomControl } from "../contexts";
import "../style/controls/cssMarginInput.scss";
const REMOVE_LEADING_ZERO_REGEXP = /^0+0/;
const CssMarginInput = ()=>{
    const { value, setValue, params: { dashicon } } = useCustomControl();
    const handleChange = (e)=>{
        const inputValue = +e.target.value;
        const newValue = [
            ...value
        ];
        newValue.splice(+e.target.dataset.index, 1, inputValue);
        setValue(newValue);
    };
    const createInput = (index)=>/*#__PURE__*/ _jsx("input", {
            type: "number",
            value: value[index].toString().replace(REMOVE_LEADING_ZERO_REGEXP, ""),
            "data-index": index,
            onChange: handleChange
        });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {}),
                    /*#__PURE__*/ _jsx("div", {
                        children: createInput(0)
                    }),
                    /*#__PURE__*/ _jsx("div", {})
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: createInput(3)
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx("span", {
                            className: `dashicons dashicons-${dashicon}`
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: createInput(1)
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {}),
                    /*#__PURE__*/ _jsx("div", {
                        children: createInput(2)
                    }),
                    /*#__PURE__*/ _jsx("div", {})
                ]
            })
        ]
    });
};
export { CssMarginInput };
